import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import spriteUrl from '../img/veengu-icons-sprite.svg';

interface VeenguIconProps extends SvgIconProps {
  name: string;
}

const VeenguIcon = ({ name, ...props }: VeenguIconProps) => (
  <SvgIcon {...props}>
    <use href={`${spriteUrl}#icon-${name}`} />
  </SvgIcon>
);

export default VeenguIcon;
